import { render } from "./MosaicManager.vue?vue&type=template&id=0b424836&scoped=true"
import script from "./MosaicManager.vue?vue&type=script&lang=js"
export * from "./MosaicManager.vue?vue&type=script&lang=js"

import "./MosaicManager.vue?vue&type=style&index=0&id=0b424836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b424836"]])

export default __exports__